/**
 * Application Configuration Constants
 * Environment URLs, API endpoints, and application settings
 */

// export const ENV_URL = 'http://localhost:3000';
export const ENV_URL = 'https://app.sustainable-discipleship.com';
export const BASE_URL = `${ENV_URL}/api/v1`;
export const FILE_PATH_REPORT = `${ENV_URL}/api/reports`;
export const GCAPTCHA_CLIENT_KEY = process.env.REACT_APP_GCAPTCHA_KEY;

export const CONFIG = {
  POSTHOG_KEY: process.env.REACT_APP_POSTHOG_KEY,
  POSTHOG_HOST: process.env.REACT_APP_POSTHOG_HOST,
  GCAPTCHA_CLIENT_KEY: process.env.REACT_APP_GCAPTCHA_KEY,
  OUTSIDE_BOOKS_LINK: 'https://disciples.sustainable-discipleship.com',
  GET_STARTED_LINKS: {
    ONE: 'https://www.sustainable-discipleship.com/the-book/',
    TWO: 'https://sustainable-discipleship.com',
    THREE: 'https://sustainable-discipleship.com/resources'
  },
  D2I_SITE: {
    NAME: 'D2i Technology',
    URL: 'https://d2itechnology.com'
  },
  CONTACT_URL: 'app@sustainable-discipleship.com'
};
